const BoosterProfileModel = {};

BoosterProfileModel.TABLE_MAP = {
  ORDER: 1,
  CUSTOM_ORDER: 2,
  BOOSTER_PROFILE: 3,
};

BoosterProfileModel.STATUSES = {
  WAITING_FOR_APPROVE: {
    id: 1,
    title: 'Waiting for approve',
  },
  APPROVED: {
    id: 2,
    title: 'Approved',
  },
  DECLINED: {
    id: 3,
    title: 'Declined',
  },
  REVISION: {
    id: 4,
    title: 'Revision',
  },
  SHADOWBAN: {
    id: 5,
    title: 'Shadow ban',
  },
};

BoosterProfileModel.STATUSES.ID_TO_DATA = {
  [BoosterProfileModel.STATUSES.WAITING_FOR_APPROVE.id]: BoosterProfileModel.STATUSES.WAITING_FOR_APPROVE,
  [BoosterProfileModel.STATUSES.APPROVED.id]: BoosterProfileModel.STATUSES.APPROVED,
  [BoosterProfileModel.STATUSES.DECLINED.id]: BoosterProfileModel.STATUSES.DECLINED,
  [BoosterProfileModel.STATUSES.REVISION.id]: BoosterProfileModel.STATUSES.REVISION,
  [BoosterProfileModel.STATUSES.SHADOWBAN.id]: BoosterProfileModel.STATUSES.SHADOWBAN,
};

BoosterProfileModel.SOCKET = {
  SERVICES_ROOM_FLAG: 'services',
  NOTIFICATIONS_ROOM_FLAG: 'notifications',
  ORDER_CHANGES_ROOM_FLAG: 'orderChanges',
};

BoosterProfileModel.FILTERS_MAP = {
  games: 'with_any_json_root_tag_ids',
  platforms: 'with_in_platform_id',
  regions: 'with_in_region_id',
  prices: 'with_between_booster_price',
  deadline: 'with_between_deadline_at',
  status: 'with_status',
  in_status: 'with_in_status',
};

BoosterProfileModel.BOOSTER_POLL_STATE = {
  NOT_SHOWN: {
    id: 1,
    title: 'Not shown',
  },
  SKIPPED: {
    id: 2,
    title: 'Skipped',
  },
  FILLED: {
    id: 3,
    title: 'Filled',
  },
};

export default BoosterProfileModel;
